import React, { useCallback } from 'react';

import { cssMap } from '@atlaskit/css';
import RovoChatIcon from '@atlaskit/icon/core/rovo-chat';
import { Pressable, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const FollowUpButton = ({
	followUp,
	onFollowUp,
}: {
	followUp: string;
	onFollowUp: (followUpQuestion: string) => void;
}) => {
	const handleClick = useCallback(() => {
		onFollowUp(followUp);
	}, [onFollowUp, followUp]);

	return (
		<Pressable xcss={styles.followUpButton} onClick={handleClick}>
			<RovoChatIcon label="" color={token('color.icon.subtle')} />
			<Text size="small" color="color.text.subtle">
				{followUp}
			</Text>
		</Pressable>
	);
};

export const FollowUpQuestions = ({
	questions,
	onFollowUp,
}: {
	questions: readonly (string | null | undefined)[];
	onFollowUp: (followUpQuestion: string) => void;
}) => {
	if (questions.length === 0) {
		return null;
	}

	return (
		<Stack space="space.100" alignInline="start">
			{questions.map((followUp) =>
				followUp ? (
					<FollowUpButton key={followUp} followUp={followUp} onFollowUp={onFollowUp} />
				) : null,
			)}
		</Stack>
	);
};

const styles = cssMap({
	followUpButton: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: token('space.100'),
		paddingBlockStart: token('space.100'),
		paddingBlockEnd: token('space.100'),
		paddingInlineStart: token('space.150'),
		paddingInlineEnd: token('space.150'),
		backgroundColor: 'transparent',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.large'),
		cursor: 'pointer',
		textAlign: 'start',
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
	},
});
